import noop from 'lodash/noop';
import { createContext } from 'react';
import { ProfileSettingsState } from './types';

export const ProfileSettingsContext = createContext<ProfileSettingsState>({
  settings: {},
  setSetting: noop,
  isSaving: false,
});
